/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { CellValueWithCounts } from "./CellValueWithCounts";
export const CellsResponseData = core.serialization.record(core.serialization.string(), core.serialization.list(CellValueWithCounts));
